import script from "./BaseCalculatorBranchSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseCalculatorBranchSelection.vue?vue&type=script&setup=true&lang=ts"

import "./BaseCalculatorBranchSelection.vue?vue&type=style&index=0&id=316fbbfe&lang=scss"

const __exports__ = script;

export default __exports__